import * as Immutable from "immutable";
import * as React from "react";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { Select } from "components/common";
import TeamsDomain from "../../domainActions/TeamsDomain";
const StyledButton = styled(Button)`
  margin-left: 15px;
`;
const FormElements = styled.div`
  display: flex;
`;
const TeamSelectOption = styled.div`
  display: flex;
  align-items: center;
`;
const StyledSelect = styled(Select)`
  flex: 1;
`;
const _renderTeamOption = ({ label }) => /* @__PURE__ */ React.createElement(TeamSelectOption, null, label);
const _options = (teams, getUnassignedTeams) => getUnassignedTeams(teams).toArray().map((t) => ({ label: t.name, value: t.id }));
const _assignTeams = (onSubmit, selectedTeamIds, setSelectedTeamIds, setIsSubmitting) => {
  if (!selectedTeamIds) {
    return;
  }
  onSubmit(Immutable.Set(selectedTeamIds.split(","))).then(() => {
    setSelectedTeamIds();
    setIsSubmitting(false);
  });
};
const _loadTeams = (setPaginatedTeams) => {
  const getUnlimited = { page: 1, perPage: 0, query: "" };
  TeamsDomain.loadTeamsPaginated(getUnlimited).then(setPaginatedTeams);
};
const TeamsSelector = ({ getUnassignedTeams, onSubmit, showCreationForm }) => {
  const [paginatedTeams, setPaginatedTeams] = useState();
  const [selectedTeamIds, setSelectedTeamIds] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { list: teams } = paginatedTeams || { list: Immutable.List() };
  const _onSubmit = () => _assignTeams(onSubmit, selectedTeamIds, setSelectedTeamIds, setIsSubmitting);
  useEffect(() => _loadTeams(setPaginatedTeams), [showCreationForm]);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(FormElements, null, /* @__PURE__ */ React.createElement(
    StyledSelect,
    {
      onChange: setSelectedTeamIds,
      optionRenderer: _renderTeamOption,
      options: _options(teams, getUnassignedTeams),
      multi: true,
      placeholder: "Search for teams",
      value: selectedTeamIds
    }
  ), /* @__PURE__ */ React.createElement(
    StyledButton,
    {
      bsStyle: "primary",
      onClick: _onSubmit,
      disabled: isSubmitting || !selectedTeamIds,
      title: "Assign user to team",
      type: "submit"
    },
    "Assign Team"
  ), /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "info", title: "Quick Create team", onClick: showCreationForm }, "Quick Create Team")));
};
export default TeamsSelector;
